// src/components/Pagination.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { PaginationProps } from '@/types';
import SvgDireccionIzquierda from '@/icons/SvgDireccionIzquierda';



/**
 * 🧩 Componente Pagination con efecto cristal / gota de agua
 */

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const maxPagesToShow = 3;

  const renderPaginationButtons = () => {
    const pages = [];
    let startPage = 1;
    let endPage = totalPages;

    if (totalPages > maxPagesToShow) {
      if (currentPage <= Math.ceil(maxPagesToShow / 2)) {
        endPage = maxPagesToShow;
      } else if (currentPage >= totalPages - Math.floor(maxPagesToShow / 2)) {
        startPage = totalPages - maxPagesToShow + 1;
      } else {
        startPage = currentPage - Math.floor(maxPagesToShow / 2);
        endPage = currentPage + Math.floor(maxPagesToShow / 2);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <motion.button
          key={i}
          onClick={() => onPageChange(i)}
          initial={{ opacity: 0, filter: "blur(4px)" }}
          animate={{ opacity: 1, filter: "blur(0px)" }}
          whileHover={currentPage !== i ? { scale: 1.15 } : {}}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className={`
            mx-1 px-4 py-1 rounded-xl
            border border-b-2 border-r-4 border-zinc-400
            font-mono font-extrabold
            ${currentPage === i
              ? 'bg-zinc-800 text-white !border-blue-800 cursor-default' // Página activa
              : 'bg-zinc-100/10 text-zinc-800 backdrop-blur-sm hover:bg-zinc-100/50 hover:backdrop-blur-3xl hover:border-blue-700 hover:shadow-lg cursor-pointer'}
            transition-all duration-300
          `}
        >
          {i}
        </motion.button>
      );
    }

    return pages;
  };

  return (
    <div className="mt-4 flex justify-center mb-2">
      {currentPage > 1 && (
        <motion.button
          onClick={() => onPageChange(currentPage - 1)}
          initial={{ opacity: 0, filter: "blur(4px)" }}
          animate={{ opacity: 1, filter: "blur(0px)" }}
          whileHover={{ scale: 1.15 }}
          transition={{ duration: 0.3 }}
          className={`
      mx-1 px-3 rounded-xl
      border border-b-2 border-l-4 border-zinc-400
      bg-zinc-100/10 backdrop-blur-sm
      text-white
      hover:bg-zinc-100/50 hover:backdrop-blur-3xl
      hover:border-blue-700 hover:shadow-lg
      transition-all duration-300
      focus:outline-none focus:ring-0 focus:shadow-sm
    `}
        >
          <SvgDireccionIzquierda />
        </motion.button>
      )}


      {renderPaginationButtons()}

      {currentPage < totalPages && (
        <motion.button
          onClick={() => onPageChange(currentPage + 1)}
          initial={{ opacity: 0, filter: "blur(4px)" }}
          animate={{ opacity: 1, filter: "blur(0px)" }}
          whileHover={{ scale: 1.15 }}
          transition={{ duration: 0.3 }}
          className={`
      mx-1 px-3 rounded-xl
      border border-b-2 border-r-4 border-zinc-400
      bg-zinc-100/10 backdrop-blur-sm
      text-white
      hover:bg-zinc-100/50 hover:backdrop-blur-3xl
      hover:border-blue-700 hover:shadow-lg
      transition-all duration-300
      focus:outline-none focus:ring-0 focus:shadow-sm
    `}
        >
          <SvgDireccionIzquierda className="rotate-180" />
        </motion.button>
      )}

    </div>
  );
};

export default Pagination;